import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Sale/Sale'));

export default Loadable;
